/* eslint-disable prettier/prettier */
import Search from "./components/RpaSearch.vue";
import i18n from "@/i18n";
import { STATIC_IMG_PATH } from "@/views/zhiji/js/common/constants.js";
import { stringRegExp } from "@/views/zhiji/components/commonForm/rules.js";

// 列配置
export const columns = [
  {
    colId: 'check',
    type: 'Checkbox',
    header: '',
    width: '37px',
  },
  {
    type: 'Link',
    colId: 'name',
    header: 'RPA名称',
  },
  {
    type: 'Text',
    colId: 'triggerCount',
    header: '使用次数',
    width: '200px',
  },
  {
    type: 'Text',
    colId: 'editTime',
    header: '更新时间',
    width: '260px',
  },
  {
    type: 'Status',
    colId: 'status',
    header: '状态',
    width: '180px',
  },
  {
    type: 'Operation',
    colId: 'operator',
    header: '操作',
    width: '160px',
  },
];

export const bottomButtons =  [
  {
      id: "del",
      text: i18n.t("zhiji.common.delete"),
      icon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px 0px",
      hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px -22px",
  },
  {
      id: "online",
      text: i18n.t("zhiji.knowlege.online"),
      icon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -210px 0px",
      hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -210px -20px"
  },
  {
      id: "offline",
      text: i18n.t("zhiji.knowlege.offline"),
      icon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -230px 0px",
      hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -230px -20px"
  },
]

export const pageLength = 10;

export const pageLengthRank = [10, 20, 30, 100];

export const searchFilter = [
  {
    props: {
      name: 'filterFields',
      inline: true,
      subItemLabelPosition: 'left',
    },
    uId: '0',
    cid: 'Form',
    events: [],
    children: [
      {
        props: {
          style: {
            width: '200px',
          },
          options: [
            {
                label: '按更新时间排序',
                value: '1'
            },
            {
                label: '按使用次数排序',
                value: '2'
            }
        ],
          name: 'order',
        },
        uId: '1',
        cid: 'Select',
        events: [],
        children: [],
      },
      {
        props: {
          style: {
            width: '200px',
          },
          value: '1',
          options: [
            {
                label: '所有状态',
                value: ''
            },
            {
                label: '已上线',
                value: '1'
            },
            {
              label: '已下线',
              value: '0'
            }
        ],
          name: 'status',
        },
        uId: '2',
        cid: 'Select',
        events: [],
        children: [],
      },
      {
        props: {
          style: {
            width: '270px',
          },
          placeholder: '输入RPA关键字',
          maxLength: 100,
          name: 'searchText',
          autocomplete: 'off'
        },
        uId: '3',
        cid: Search,
        events: [],
        children: [],
      },
    ],
  },
];
export const addRpaConfig = [
  {
    props: {
      name: 'addRpa',
      // inline: true,
      subItemLabelPosition: 'left',
      subItemLabelWidth: '80',
    },
    uId: '4',
    cid: 'Form',
    events: [],
    children: [
      {
        props: {
          style: {
            width: '500px',
          },
          label: 'RPA名称',
          placeholder: "请输入",
          name: 'rpaName',
          required: true,
        },
        uId: '5',
        cid: 'TextInput',
        events: [],
        children: [],
      }
    ],
  },
];

export const rules = {
  addRpa: {
    rpaName: [{
      required: true,
    }, {
      regExp: /<|>/,
      validator: stringRegExp,
      message: '名称不可携带<>,会有xss安全风险',
    }],
  }
};

